(function() {
  var CropYear, Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  CropYear = App.loadClass('core::CropYear');

  exports.NSolverService = (function(superClass) {
    extend(NSolverService, superClass);

    function NSolverService(http, rootScope, state, stateParams, q, session) {
      this.http = http;
      this.rootScope = rootScope;
      this.state = state;
      this.stateParams = stateParams;
      this.q = q;
      this.session = session;
      this.stepComplete = bind(this.stepComplete, this);
      this.surveyComplete = bind(this.surveyComplete, this);
      this.fieldSurveyComplete = bind(this.fieldSurveyComplete, this);
      this.stepCompleteForFieldSurvey = bind(this.stepCompleteForFieldSurvey, this);
      this.allInputsComplete = bind(this.allInputsComplete, this);
      this.inputComplete = bind(this.inputComplete, this);
      this.inputSet = bind(this.inputSet, this);
      this.eventsWidgetComplete = bind(this.eventsWidgetComplete, this);
      this.fillFieldSurveys = bind(this.fillFieldSurveys, this);
      this.save = bind(this.save, this);
      this.findStepIndexByName = bind(this.findStepIndexByName, this);
      this.gotoStep = bind(this.gotoStep, this);
      this.createSurvey = bind(this.createSurvey, this);
      this.loadConfig = bind(this.loadConfig, this);
      this.loadNMaps = bind(this.loadNMaps, this);
      this.reset = bind(this.reset, this);
      this.reset();
      this.config = {};
      this.year = null;
      this.crop = null;
      this.rxMaps = {};
      this.configLoaded = this.loadConfig();
    }

    NSolverService.prototype.reset = function() {
      this.surveyId = null;
      this.survey = null;
      this.year = null;
      this.crop = null;
      this.fields = [];
      this.currentStepIndex = 0;
      this.currentStepName = '';
      this.brandNew = false;
      this.nextAttempted = false;
      this.saving = null;
      this.triggerBrowserWarning = true;
      return this.loadNMaps();
    };

    NSolverService.prototype.loadNMaps = function() {
      return this.http.get("api/nitrogen-rx-maps?year=" + (new CropYear().get())).then((function(_this) {
        return function(response) {
          var i, len, map, ref, results;
          ref = response.data;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            map = ref[i];
            results.push(_this.rxMaps[map.fields_id] = map);
          }
          return results;
        };
      })(this));
    };

    NSolverService.prototype.loadConfig = function() {
      return this.http.get('backend/grower/nsolver/config').then((function(_this) {
        return function(response) {
          return _this.config = response.data;
        };
      })(this));
    };

    NSolverService.prototype.createSurvey = function(year, crop) {
      this.year = year;
      this.crop = crop;
      return this.http.post('api/nitrogen-surveys', {
        crops_id: crop,
        companies_id: this.session.get('SelectedCompany-grower'),
        year: year
      }).then((function(_this) {
        return function(response) {
          _this.survey = response.data;
          _this.crop = _this.survey.crop.name;
          return response;
        };
      })(this));
    };

    NSolverService.prototype.gotoStep = function(stepNumber, id, saveData) {
      var currentStepName;
      if (saveData == null) {
        saveData = true;
      }
      if (!id) {
        id = this.stateParams.id;
      }
      if (!id) {
        throw new Error("N Solver: Going to step " + stepNumber + " but no survey id specified!");
      }
      if (saveData) {
        this.save(id);
      }
      this.currentStepIndex = stepNumber;
      this.currentStepName = _.findKey(this.config.steps, (function(_this) {
        return function(obj) {
          return obj.order === stepNumber;
        };
      })(this));
      if (this.currentStepName) {
        currentStepName = this.currentStepName;
        this.survey.visited_steps.push(currentStepName);
        this.survey.visited_steps = _.uniq(this.survey.visited_steps);
      }
      this.nextAttempted = false;
      return this.state.go('grower.nsolver.step', {
        id: id,
        step: stepNumber + 1
      });
    };

    NSolverService.prototype.findStepIndexByName = function(stepName) {
      return this.config.steps[stepName]['order'];
    };

    NSolverService.prototype.save = function(id) {
      var fieldSurvey, i, len, ref;
      if (!this.survey) {
        return;
      }
      if (this.currentStepName) {
        this.survey.saved_steps.push(this.currentStepName);
        this.survey.saved_steps = _.uniq(this.survey.saved_steps);
      }
      ref = this.survey.fields_nitrogen_surveys;
      for (i = 0, len = ref.length; i < len; i++) {
        fieldSurvey = ref[i];
        fieldSurvey.complete = this.fieldSurveyComplete(fieldSurvey);
      }
      return this.saving = this.http.put("api/nitrogen-surveys/" + id, this.survey).then((function(_this) {
        return function(response) {
          var j, len1, ref1, results;
          if (_this.survey) {
            ref1 = response.data.fields_nitrogen_surveys;
            results = [];
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              fieldSurvey = ref1[j];
              results.push(_.find(_this.survey.fields_nitrogen_surveys, {
                fields_id: fieldSurvey.fields_id
              }).events = fieldSurvey.events);
            }
            return results;
          }
        };
      })(this));
    };

    NSolverService.prototype.fillFieldSurveys = function(inputName, value) {
      var fieldSurvey, i, len, ref, results;
      ref = this.survey.fields_nitrogen_surveys;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        fieldSurvey = ref[i];
        results.push(fieldSurvey.data[inputName] = value);
      }
      return results;
    };

    NSolverService.prototype.eventsWidgetComplete = function(fieldSurvey) {
      return fieldSurvey.events.planting.length;
    };

    NSolverService.prototype.inputSet = function(inputName, fieldSurvey) {
      return fieldSurvey.data[inputName] !== void 0 && fieldSurvey.data[inputName] !== null;
    };

    NSolverService.prototype.inputComplete = function(inputName, fieldSurvey) {
      if (inputName === 'standing_residue' && fieldSurvey.data['tillage_practice'] !== 'No-Till') {
        return true;
      }
      if (inputName === 'historical_yield') {
        return ("" + fieldSurvey.data[inputName]) === ("" + (+fieldSurvey.data[inputName])) && +fieldSurvey.data[inputName] < 1000;
      }
      return this.inputSet(inputName, fieldSurvey);
    };

    NSolverService.prototype.allInputsComplete = function(config, fieldSurvey) {
      return _.every(config, (function(_this) {
        return function(inputConfig, inputName) {
          var ref;
          return ((ref = inputConfig.value.required) != null ? ref.value : void 0) !== true || _this.inputComplete(inputName, fieldSurvey);
        };
      })(this));
    };

    NSolverService.prototype.stepCompleteForFieldSurvey = function(stepName, fieldSurvey) {
      return _.every(this.config.steps[stepName].value, (function(_this) {
        return function(widgetConfig, widgetName) {
          if (widgetName === 'events') {
            return _this.eventsWidgetComplete(fieldSurvey);
          }
          return _this.allInputsComplete(widgetConfig.value, fieldSurvey);
        };
      })(this));
    };

    NSolverService.prototype.fieldSurveyComplete = function(fieldSurvey) {
      return _.every(this.config.steps, (function(_this) {
        return function(stepConfig, stepName) {
          return _this.stepCompleteForFieldSurvey(stepName, fieldSurvey);
        };
      })(this));
    };

    NSolverService.prototype.surveyComplete = function(survey) {
      if (survey == null) {
        survey = this.survey;
      }
      if (!survey) {
        return true;
      }
      return _.every(survey.fields_nitrogen_surveys, (function(_this) {
        return function(fieldSurvey) {
          return _this.fieldSurveyComplete(fieldSurvey);
        };
      })(this));
    };

    NSolverService.prototype.stepComplete = function(stepName, survey) {
      if (survey == null) {
        survey = this.survey;
      }
      if (!survey) {
        return false;
      }
      return survey.fields_nitrogen_surveys.length && _.every(survey.fields_nitrogen_surveys, (function(_this) {
        return function(fieldSurvey) {
          return _this.stepCompleteForFieldSurvey(stepName, fieldSurvey);
        };
      })(this));
    };

    return NSolverService;

  })(Service);

}).call(this);
